import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Collapse } from 'antd';
import { getContentWrapperStyle } from '../templateStyles';

const { Title, Paragraph } = Typography;

export default function SectionFAQ({ section, siteInfo }) {
  const { t } = useTranslation();
  const items = section.config?.items || [];
  if (items.length === 0) return null;

  const brandColor = siteInfo?.brand_color || '#1890ff';
  const template = siteInfo?.site_template || 'modern';
  const isMinimal = template === 'minimal';
  const isClassic = template === 'classic';
  const contentFont = getContentWrapperStyle(template, brandColor);

  const cardRadius = isMinimal ? 0 : isClassic ? 4 : 8;

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '48px 24px', ...contentFont }}>
      <Title level={2} style={{
        textAlign: isMinimal ? 'left' : 'center',
        marginBottom: 32,
        fontWeight: isMinimal ? 300 : 600,
        letterSpacing: isMinimal ? 1 : 0,
        borderBottom: isMinimal ? `2px solid ${brandColor}` : 'none',
        paddingBottom: isMinimal ? 8 : 0,
        display: isMinimal ? 'inline-block' : 'block',
      }}>
        {section.title || t('sections.faq.title')}
      </Title>
      <Collapse
        items={items.map((item, i) => ({
          key: i,
          label: <span style={{ fontWeight: 600 }}>{item.question || item.q}</span>,
          children: <Paragraph style={{ lineHeight: 1.8 }}>{item.answer || item.a}</Paragraph>,
        }))}
        bordered={isMinimal}
        style={{
          background: '#fff',
          borderRadius: cardRadius,
          border: isMinimal ? '1px solid #e8e8e8' : 'none',
          boxShadow: isMinimal ? 'none' : isClassic ? '0 1px 4px rgba(0,0,0,0.08)' : '0 2px 8px rgba(0,0,0,0.06)',
        }}
      />
    </div>
  );
}
